import { render } from "./AppNavigationMenu.vue?vue&type=template&id=bd5e2b6c&scoped=true"
import script from "./AppNavigationMenu.vue?vue&type=script&lang=js"
export * from "./AppNavigationMenu.vue?vue&type=script&lang=js"

import "./AppNavigationMenu.vue?vue&type=style&index=0&id=bd5e2b6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd5e2b6c"]])

export default __exports__